import { render, staticRenderFns } from "./ClusterPhonesForm.vue?vue&type=template&id=67fcf202"
import script from "./ClusterPhonesForm.vue?vue&type=script&lang=js"
export * from "./ClusterPhonesForm.vue?vue&type=script&lang=js"
import style0 from "./ClusterPhonesForm.vue?vue&type=style&index=0&id=67fcf202&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports